;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export const titleContainsSandYou = (title: string | undefined | null): boolean => (title || '').toLowerCase().includes('s&you');
export const titleContainsSynergie = (title: string | undefined | null): boolean =>
  (title || '').toLowerCase().includes('synergie');

const SYNERGIE_BRAND_NAME = 'Synergie';

export const getAgencyDisplayTitle = ({
  title,
  prependBrandName = false,
}: {
  title: string | undefined | null;
  prependBrandName?: boolean;
}): string => {
  if (!prependBrandName || titleContainsSandYou(title) || titleContainsSynergie(title)) return (title || '').trim();
  return `${SYNERGIE_BRAND_NAME} ${title || ''}`.trim();
};
